import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { closest } from 'next/javascripts/modules/dom';
import 'next/stylesheets/components/todos-group';

Component('tr-todos-group', {
  mixins: [eventListenerMixin],

  properties: {
    folded: {
      type: Boolean,
      default: false,
    },

    storageKey: {
      type: String,
      default: '',
    },

    count: {
      type: Number,
      default: 0,
      observer: 'countChanged',
    },
  },

  ready() {
    this.folded = !!this.getFoldedFromStorage();
  },

  connected() {
    this.listenTo(this, 'click', (event) => {
      if (closest(event.target, '.group-title', this)) {
        this.folded = !this.folded;
        this.saveFoldedToStorage(this.folded);
      }
    });
  },

  getFoldedFromStorage() {
    if (!this.storageKey || localStorage.getItem(this.storageKey) === null) {
      return this.folded;
    }
    return localStorage.getItem(this.storageKey);
  },

  saveFoldedToStorage(folded) {
    if (this.storageKey) {
      if (folded) {
        localStorage.setItem(this.storageKey, folded);
      } else {
        localStorage.removeItem(this.storageKey);
      }
    }
  },

  countChanged(count) {
    this.querySelector('.group-name').setAttribute('todo-count', count);
  },

  disconnected() {
    this.stopListening();
  },
});
